import * as acConfigureNotificationTypes from './acConfigureNotificationTypes';

const acConfigureNotificationInitialState: AcConfigureNotificationState = {
  acConfigureNotification: null,
  acConfigureNotificationCount: 0,
  acConfigureNotificationListRequestHash: null,
  acConfigureNotificationListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'ascending',
    sortBy: 'name',
    searchTerm: '',
  },
  acConfigureNotificationFiltersAppliedFromRedirection: false,
  acConfigureNotificationTableLoader: false,
  acIndividualAlarmDetails: null,

  acConfigureNotificationHistory: null,
  acConfigureNotificationHistoryCount: 0,
  acConfigureNotificationHistoryListTableProps: {
    view: 'list',
    pageSize: 15,
    pageNumber: 1,
    order: 'descending',
    sortBy: 'fireTime',
    searchTerm: '',
  },
  acConfigureNotificationHistoryListRequestHash: null,
  acConfigureNotificationHistoryTimeline: null,
  acGetLatestConfigurationOnTop: false,
};

const acConfigureNotificationReducer = (
  state: AcConfigureNotificationState = acConfigureNotificationInitialState,
  action: AcConfigureNotificationAction,
): AcConfigureNotificationState => {
  switch (action.type) {
    case acConfigureNotificationTypes.FETCH_AC_CONFIGURE_NOTIFICATIONS:
      return {
        ...state,
        acConfigureNotificationCount: action.acConfigureNotificationCount,
        acConfigureNotification: action.acConfigureNotification,
      };
    case acConfigureNotificationTypes.FETCH_AC_CONFIGURE_NOTIFICATIONS_HISTORY:
      return {
        ...state,
        acConfigureNotificationHistoryCount: action.acConfigureNotificationHistoryCount,
        acConfigureNotificationHistory: action.acConfigureNotificationHistory,
      };
    case acConfigureNotificationTypes.SET_AC_NOTIFICATION_LIST_REQUEST_HASH:
      return {
        ...state,
        acConfigureNotificationListRequestHash: action.acConfigureNotificationListRequestHash,
      };
    case acConfigureNotificationTypes.SET_AC_NOTIFICATION_HISTORY_LIST_REQUEST_HASH:
      return {
        ...state,
        acConfigureNotificationHistoryListRequestHash: action.acConfigureNotificationHistoryListRequestHash,
      };
    case acConfigureNotificationTypes.SET_AC_RULE_STATUS:
      return { ...state };
    case acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LIST_TABLE_PROPS:
      return {
        ...state,
        acConfigureNotificationListTableProps: action.acConfigureNotificationListTableProps,
      };
    case acConfigureNotificationTypes.CREATE_AC_NEW_RULE:
      return { ...state };
    case acConfigureNotificationTypes.EDIT_AC_NEW_RULE:
      return { ...state };
    case acConfigureNotificationTypes.FETCH_AC_RULE_FOR_EDIT:
      return { ...state };
    case acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LOADER:
      return {
        ...state,
        acConfigureNotificationTableLoader: action.acConfigureNotificationTableLoader,
      };
    case acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_STATUS_LOADER:
      return {
        ...state,
        acConfigureNotificationTableLoader: action.acConfigureNotificationTableLoader,
      };
    case acConfigureNotificationTypes.CLEAR_AC_CONFIGURE_NOTIFICATION_LIST_DATA:
      return {
        ...state,
        acConfigureNotificationListTableProps: {
          view: 'list',
          pageSize: state.acConfigureNotificationListTableProps?.pageSize || 15,
          pageNumber: state.acConfigureNotificationListTableProps?.pageNumber || 1,
          order: state.acConfigureNotificationListTableProps?.order || 'ascending',
          sortBy: state.acConfigureNotificationListTableProps?.sortBy || 'name',
          searchTerm: '',
        },
        acConfigureNotification: null,
      };
    case acConfigureNotificationTypes.CLEAR_AC_CONFIGURE_NOTIFICATION_HISTORY_LIST_DATA:
      return {
        ...state,
        acConfigureNotificationHistoryListTableProps: {
          view: 'list',
          pageSize: state.acConfigureNotificationHistoryListTableProps?.pageSize || 15,
          pageNumber: state.acConfigureNotificationHistoryListTableProps?.pageNumber || 1,
          order: state.acConfigureNotificationHistoryListTableProps?.order || 'descending',
          sortBy: state.acConfigureNotificationHistoryListTableProps?.sortBy || 'fireTime',
          searchTerm: '',
        },
        acConfigureNotificationHistory: null,
      };
    case acConfigureNotificationTypes.FETCH_AC_CONFIGURE_NOTIFICATION_HISTORY_TIMELINE:
      return {
        ...state,
        acConfigureNotificationHistoryTimeline: action.acConfigureNotificationHistoryTimeline,
      };
    case acConfigureNotificationTypes.CLEAR_AC_CONFIGURE_NOTIFICATION_HISTORY_TIMELINE:
      return {
        ...state,
        acConfigureNotificationHistoryTimeline: null,
        acConfigureNotificationHistory: null,
      };
    case acConfigureNotificationTypes.SET_AC_LATEST_CONFIGURATION_ON_TOP:
      return {
        ...state,
        acGetLatestConfigurationOnTop: action.acGetLatestConfigurationOnTop,
      };
    default:
      return state;
  }
};

export default acConfigureNotificationReducer;
